import { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { PequiChatbotWidget } from './PequiChatbotWidget.tsx';

export const PequiChatbotWidgetWrapper = () => {
  const identity = useApi(identityApiRef);

  const [loading, setLoading] = useState(true);
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    let mounted = true;

    identity
      .getBackstageIdentity()
      .then(() => {
        if (mounted) {
          setIsSignedIn(true);
          setLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setIsSignedIn(false);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [identity]);

  if (loading || !isSignedIn) {
    return null;
  }

  return <PequiChatbotWidget />;
};
